
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NeedGear } from '@/interfaces/loot'

@Component
export default class NeedRaidItem extends Vue {
  @Prop()
  entry!: NeedGear

  @Prop()
  itemsReceived!: number

  @Prop()
  requesting!: boolean

  @Prop()
  userHasPermission!: boolean

  save(): void {
    this.$emit('save')
  }
}
